import * as types from '../constants'

const initialState = {
    isFetching: true,
    listProduct: [],
    pageProduct: [],
    productItem: {},
    filterName: '',
    filterCategory: '',
    filterPrice: '',
    sortBy: '',
    sortValue: 1,
    totalProduct: 0
}

export default (state = initialState, action) => {
    switch (action.type) {
        case types.GET_ALL_PRODUCT_SUCCESS:
            return {
                ...state,
                isFetching: false,
                listProduct: action.payload,
                totalProduct: action.payload.length
            }
        case types.GET_PRODUCT_DETAIL_SUCCESS:
            return {
                ...state,
                productItem: action.payload
            }
        case types.SEARCH_PRODUCTS:
            return {
                ...state,
                listProduct: action.payload,
                totalProduct: action.payload.length
            }
        case types.FILTER_VALUE:
            return {
                ...state,
                filterName: action.payload.filterName,
                filterCategory: action.payload.filterCategory,
                filterPrice: action.payload.filterPrice,
            }
        case types.SORT_PRODUCTS:
            return {
                ...state,
                sortBy: action.payload.sortBy,
                sortValue: action.payload.sortValue
            }
        case types.LOAD_NEW_PAGE:
            return {
                ...state
            }
        case types.ADD_PRODUCT_SUCCESS:
            state.listProduct.push(action.payload);
            return {
                ...state,
            }
        case types.EDIT_PRODUCT_SUCCESS:
            var index = action.payload.id;
            state.listProduct[index] = action.payload
            return {
                ...state
            }
        case types.DELETE_PRODUCT_SUCCESS:
            var id = action.payload;
            state.listProduct.filter(product => {
                return product.id !== id
            })
            return {
                ...state
            }
        default:
            return state
    }
}